module.exports = __webpack_public_path__ + "img/armtool.348c6877.svg";